import { render, staticRenderFns } from "./PageHeaderPlainDark.vue?vue&type=template&id=744f4a64&"
import script from "./PageHeaderPlainDark.vue?vue&type=script&lang=js&"
export * from "./PageHeaderPlainDark.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/pages/plain-dark.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports